import * as React from 'react';

export function SvgImageStrikethrough() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 24 24">
        <path
          d="M23.2954 21.7046L21.7046 23.2954L0.70459 2.29541L2.29541 0.70459L23.2954 21.7046Z"
          fill="currentColor"
        />
        <path
          d="M3.75 8.52246V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H5.46533L9.95215 14.7246L11.5503 16.3228L8.36279 20.25H15.4775L17.7275 22.5H4.5C2.84315 22.5 1.5 21.1569 1.5 19.5V6.27246L3.75 8.52246Z"
          fill="currentColor"
        />
        <path
          d="M19.5 1.5C21.1569 1.5 22.5 2.84315 22.5 4.5V17.7275L20.25 15.4775V15.4658L15.835 11.0508L15.8291 11.0566L14.231 9.4585L14.877 8.66602L14.9561 8.57812C15.1516 8.38331 15.4131 8.26598 15.6914 8.25146C16.0095 8.23506 16.3202 8.35437 16.5454 8.57959L20.25 12.2842V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75H8.52246L6.27246 1.5H19.5Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
